import { render, staticRenderFns } from "./TypingIndicator.vue?vue&type=template&id=642c51e5&scoped=true&"
import script from "./TypingIndicator.vue?vue&type=script&lang=js&"
export * from "./TypingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./TypingIndicator.vue?vue&type=style&index=0&id=642c51e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c51e5",
  null
  
)

export default component.exports